module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAAAXNSR0IArs4c6QAAAVxJREFUOE+dlDFOw0AQRf/YBQ01lNROJA4Ad4gE0TqJjFKmAFooqLZKJI5AGYHkxAoSHIIDIOUASGmgpkHR7kQbeZETsvYal/bMW+37Myb845FSBo1Gg+I4VlS3fzqd7gN4JKKFEOK6FmA2mx0ppV4BHOcHX3oDsiw7YeZnAId5MxPRyAuQpmk/CIIHAHt58w8RDYQQ41KAkdVsNofMfAvA1n4R0ZkQ4s3AnIBc1hOAVkH0exiGrXa7/WHf7QTskGXqjbwkjuPvYnJ/AA5Z9/P5/E5Kqbdj3wCUyXLNyxrgI8sJ8JVVG7BcLltJkvzarrxCFEUjIropRPuplDrv9XrrvEsB9mOWZX1m3pg4rfWg2+2OvQCmaDKZnBKRmfmDwsz7xWhPcQzSC4CLykGyEFc623Irl6lKrtc6l8n1ArjkAhh6AwxkW67W+qoWwECsXGZedDqd+gC7fPa3vgI1fr/q8UruVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/prev.png
// module id = nNSp
// module chunks = 1